var map = {
	"./1-1.jpg": 2981,
	"./1-2.jpg": 5642,
	"./1-3.jpg": 4647,
	"./1.jpg": 8171,
	"./2-1.jpg": 4882,
	"./2-2.jpg": 3837,
	"./2-3.jpg": 8272,
	"./2.jpeg": 3349,
	"./3.jpeg": 1390,
	"./author.jpg": 9189,
	"./author.png": 8213,
	"./author2.jpg": 2075,
	"./author2.png": 4771,
	"./author3.jpg": 6238,
	"./author3.png": 4010,
	"./author4.jpg": 9653,
	"./author4.png": 8677,
	"./author5.jpg": 8472,
	"./author5.png": 1164,
	"./link.png": 5916,
	"./post-banner1.jpg": 2246,
	"./post-banner2.jpg": 17,
	"./qu.png": 1830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4346;